import React from 'react'
import { IntegrationTabel, IntegrationTabelCell } from './Styles'
import { FlexRow } from '@/ui'
import { ReactComponent as SwitchIcon } from '@/assets/images/icons/switch-horizontal-02.svg'
import { ReactComponent as ArrowLeft } from '@/assets/images/icons/arrow-narrow-left.svg'
import { ReactComponent as ArrowRight } from '@/assets/images/icons/arrow-narrow-right.svg'
import { useTranslation } from 'react-i18next'
import zenegyLogo from '@/assets/images/integrations/zenegylogo.png'

interface Props {
  integrationMarkings: Array<{
    dataDirection: string
    id: string
    logo: string
    name: string
    isZenegy: boolean
  }>
}

const IntegrationModal = ({ integrationMarkings }: Props) => {
  const { t } = useTranslation()

  const dataDirectionOptions = {
    sends: (
      <>
        <ArrowRight />
        {t('Sends data')}
      </>
    ),
    receives: (
      <>
        <ArrowLeft />
        {t('Receives data')}
      </>
    ),
    both: (
      <>
        <SwitchIcon />
        {t('Sends and receives data')}
      </>
    ),
  }

  console.log(integrationMarkings)
  return (
    <div>
      <IntegrationTabel>
        {integrationMarkings?.map(
          ({ dataDirection, id, logo, name, isZenegy }) => (
            <FlexRow alignItems="center" noMargin key={id}>
              <IntegrationTabelCell padding="10px 8px">
                <img src={isZenegy ? zenegyLogo : logo} />
                <span>{name}</span>
              </IntegrationTabelCell>

              <IntegrationTabelCell padding="20px" greyBackground>
                {dataDirectionOptions[dataDirection]}
              </IntegrationTabelCell>
            </FlexRow>
          ),
        )}
      </IntegrationTabel>
    </div>
  )
}

export default IntegrationModal
